<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card" style="padding:20px">
            <!-- GIDEPreneur Finance Dashboard -->
            <b-row class="row ">
              <b-col class="col-12 col-sm-6 col-md-6 col-lg-6">
                <h4><i class="fa fa-solid ri-user-star-fill primary-color" aria-hidden="true"></i>&nbsp;
                  {{cvCardTitle}}
                </h4>
              </b-col>
            </b-row><!-- GIDEPreneur Finance Dashboard -->
          </div>
        <iq-card style="padding:20px">
          <b-row class="row w-100">
            <!-- Backend Search -->
            <b-col class="col-8 col-sm-8 col-md-5 col-lg-4 mb-2">
              <b-form-input class="form-control"
                @input="searchpayredeemWithParams"
                v-model="search_param"
                type="search"
                :placeholder="cvSearchText"></b-form-input>
            </b-col><!-- Backend Search -->

            <!-- Organisation Name Filter -->
            <b-col sm="4" md="2" lg="3" xl="3" class="mb-2">
              <select v-model="whereFilter.org_id" class="form-control" @change="getFilteredData" v-if="organisationObjList && organisationObjList.length > 0" title="Select Organisation">
                <option :value="null">All</option>
                <option v-for="(org, index) of organisationObjList" :key="(index+1)" :value="org.org_id">
                  {{org.org_name}}
                </option>
              </select>
            </b-col><!-- Organisation Name Filter -->

            <!-- Redemption Status Filter -->
            <b-col sm="8" md="4" lg="4" xl="4" class="mb-2">
              <div>
                <multiselect
                  v-model="selectedRedemptionStatusOptions"
                  :options="statusOptions"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Redemption Status"
                  label="label"
                  track-by="value"
                  @input="handleSelectionChange"
                >
                  <template #selection="{ values, isOpen }">
                    <span class="multiselect__single"
                          v-if="values.length"
                          v-show="!isOpen">
                    </span>
                  </template>
                </multiselect>
              </div>
            </b-col><!-- Redemption Status Filter -->
            <b-col class="col-12 col-xs-2 col-sm-2 col-md-1 col-lg-1 col-xl-1">
              <!-- <b-btn variant="primary" class="Download_button mr-2 mb-1 pull-right" @click="backendCsvDownload">CSV</b-btn> -->
              <i class="fa-solid fa-file-csv primary-color pointer font-size-30 mt-2 mr-2 Download_button" title="Download CSV" @click="backendCsvDownload"></i>
            </b-col>
          </b-row>
        </iq-card>
        <iq-card style="padding:20px">
          <b-row>
            <b-col class="container_minheight" md="12" v-if="payredeemObjList && payredeemObjList.length > 0">
              <b-table
                hover
                responsive
                :items="payredeemObjList"
                :fields="columns"
                :no-border-collapse="true"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :current-page="currentBatchNo"
                :per-page="dataPerPage"
              >
                <template v-slot:cell(pay_redeem_id)="data">
                  <div class="pull-left">
                    <span v-if="data.item.redemption_status == 'TOBEPAID'" title="Click to pay" class="pointer" @click="openProcessRedemptionModal(data.item)">
                      <b-badge :style="'background:'+getBgFor(data.item.redemption_status)">
                        {{redemptionStatusStringObj[data.item.redemption_status]}}
                      </b-badge>
                    </span>
                    <span v-else-if="data.item.redemption_status == 'TOBEAPPROVED'" title="Click to verify the GST invoice and pay" class="pointer" @click="openProcessRedemptionModal(data.item)">
                      <b-badge :style="'background:'+getBgFor(data.item.redemption_status)">
                        {{redemptionStatusStringObj[data.item.redemption_status]}}
                      </b-badge>&nbsp;
                    </span>
                    <span v-else-if="data.item.redemption_status == 'NOTREDEEMED'">
                      <span v-if="moment().diff(moment(data.item.redemption_period), 'months') >= 2" title="Awaiting Redemption" class="pointer">
                        <b-badge :style="'background:'+getBgFor(data.item.redemption_status)">
                          {{redemptionStatusStringObj[data.item.redemption_status]}}
                        </b-badge>
                      </span>
                      <span v-else>
                        <b-badge :style="'background:'+getBgFor('NOT_ELIGIBLE')" title="Revenue generated till end of the previous month will available for redemption in the next month">
                          {{redemptionStatusStringObj["NOT_ELIGIBLE"]}}
                        </b-badge>&nbsp;<i title="FAQ" class="ri-question-line pointer primary-color" style="font-size: 15px;" @click="gotoFAQList()"></i>
                      </span>
                    </span>
                    <span v-else-if="data.item.redemption_status == 'TOBEOTPVERF'" title="Awaiting OTP Verification" class="pointer">
                      <b-badge :style="'background:'+getBgFor(data.item.redemption_status)">
                        {{redemptionStatusStringObj[data.item.redemption_status]}}
                      </b-badge>&nbsp;
                    </span>
                    <span v-else-if="data.item.redemption_status == 'PAID'" title="Redeem & Payment Complete" class="pointer">
                      <b-badge :style="'background:'+getBgFor(data.item.redemption_status)">
                        {{redemptionStatusStringObj[data.item.redemption_status]}}
                      </b-badge>&nbsp;
                    </span>
                    <span v-else-if="data.item.redemption_status == 'TOBERECOVERED'" title="Adjusted for Refund" class="pointer">
                      <b-badge :style="'background:'+getBgFor(data.item.redemption_status)">
                        {{redemptionStatusStringObj[data.item.redemption_status]}}
                      </b-badge>&nbsp;
                    </span>
                    <span v-else>
                      <b-badge :style="'background:'+getBgFor(data.item.redemption_status)">
                        {{redemptionStatusStringObj[data.item.redemption_status]}}
                      </b-badge>
                    </span><br>
                    <span v-if="data.item.pay_redeem_id">
                      <small>
                        <b>Id:&nbsp;{{data.item.pay_redeem_id}}</b><br>
                        <i class="fa fa-solid fa-building-columns pointer mr-3 font-size-18" @click="getBankDetailsOfUser(data.item.bill_id)" title="View Bank Details"></i>
                        <i class="fa fa-solid fa-file-signature pointer mr-3 font-size-18" @click="openTaxInfoModal(data.item)" title="View Tax Info"></i>
                        <i class="fa fa-solid fa-folder-tree pointer mr-3 font-size-18" title="View Revenue Details" @click="viewBreakDown(data.item)"></i>
                        <i class="fa fa-solid fa-gifts pointer mr-3 font-size-18" title="View Redemption Details" @click="viewRedemption(data.item)"></i>
                        <i class="fa fa-solid fa-credit-card pointer mr-3 font-size-18" title="Make Payment" @click="openProcessRedemptionModal(data.item)" v-if="data.item.redemption_status == 'TOBEPAID'"></i>
                        <i v-if="data.item.invoice" class="fa fa-solid fa-file-invoice pointer font-size-18 mr-3" @click="openUploadGstInvoiceModal(data.item)" title="View/Update Invoice"></i>
                        <i v-if="data.item.payout_tid" class="fa fa-solid fa-file-invoice-dollar pointer font-size-18 mr-3" @click="openPayoutDetailsViewModal(data.item)" title="View Payment Details"></i>
                        <a :href="VUE_APP_GPSUPPORT_MAIL" style="color: black;"><i class="fa fa-envelope pointer font-size-18 mr-3" aria-hidden="true" title="Send Mail to Support"></i></a>
                      </small>
                    </span><br>
                    <!-- All Messages to be displayed here -->
                    <span v-if="data.item.redemption_status == 'TOBERECOVERED'"><small>Student has filed for Refund. This amount will be adjusted in your next payment</small></span>
                    <span v-if="data.item.history && data.item.history.reason_for_rejection"><small>Reason:&nbsp;{{ data.item.history.reason_for_rejection.reason_for_rejection}}</small></span>
                  </div>
                </template>

                <template v-slot:cell(org_id)="data">
                  <span class="pull-left">
                    <b>{{ data.item.org_name }}</b><br>
                    <small>Id:&nbsp;{{ data.item.org_id }}&nbsp;<i class="fa-solid fa-copy pointer" title="Copy Id" @click="doCopy(data.item.org_id)"></i></small>
                  </span>
                </template>

                <template v-slot:cell(redemption_period)="data">
                  <span class="pull-left">F.Y.&nbsp;{{data.item.redemption_period}}</span>
                </template>

                <template v-slot:cell(revenue_inr)="data">
                  <span class="pull-left">{{data.item.revenue_inr.toLocaleString()}}</span>
                </template>

                <template v-slot:cell(commission_inr_with_gst)="data">
                  <span class="pull-right">{{data.item.commission_inr_with_gst.toLocaleString()}}</span>
                </template>
                <template v-slot:cell(commission_inr_without_gst)="data">
                  <span class="pull-right">{{data.item.commission_inr_without_gst.toLocaleString()}}</span>
                </template>

                <template v-slot:cell(commission_usd_with_gst)="data">
                  <span class="pull-right">{{data.item.commission_usd_with_gst.toLocaleString()}}</span>
                </template>

                <template v-slot:cell(commission_usd_without_gst)="data">
                  <span class="pull-right">{{data.item.commission_usd_without_gst.toLocaleString()}}</span>
                </template>

                <template v-slot:cell(payout_amount)="data">
                  <span class="pull-right" v-if="data.item.payout_amount">
                    <span>{{ data.item.payout_amount.toLocaleString() }}</span>
                    <span v-if='data.item.redemption_status == "PAID" || data.item.redemption_status == "TOBEPAID" || data.item.redemption_status == "TOBEOTPVERF" || data.item.redemption_status == "TOBEAPPROVED"' class="success-color">&nbsp;Cr.</span>
                    <span v-else class="warning-color">&nbsp;Dr.</span>
                  </span>
                </template>

                <template v-slot:cell(payout_tid)="data">
                  <div class="pull-left" v-if="data.item.payout_tid">
                    <small>
                      <span v-if="data.item.payout_amount && data.item.redemption_status != 'TOBERECOVERED' && data.item.redemption_status != 'RECOVERED'">Payout Amount:&nbsp;{{data.item.payout_amount.toLocaleString()}}</span><br>
                      <span>Payout Date:&nbsp;{{data.item.payout_date}}</span><br>
                      <span>Payout Id:&nbsp;{{data.item.payout_tid}}</span>
                    </small>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col class="container_minheight" md="12" v-else>
              No data found
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="7">
              <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
            </b-col>
            <b-col sm="5" md="5">
              <b-pagination
                v-model="currentBatchNo"
                :total-rows="totalRows"
                :per-page="dataPerPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </iq-card>
      </b-col>
    </b-row>

    <!-- OrgsaastaxDocument -->
    <b-modal
      v-model="showTaxInfoDocumentModal"
      scrollable
      :title="cvTaxDocumentModalHeader"
      size="lg"
    >
      <OrgSaasTaxDocuments :propModuleObjId = "propTaxModuleObjId" :propOpenedInModal="true" @emitTaxInfoCloseEditModal="closeTaxInfoEditModal"/>
      <template #modal-footer="">
        <b-button size="sm" @click="closeTaxInfoEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal><!-- OrgsaastaxDocument -->

    <!-- Banking Details-->
    <b-modal size="xl" v-model="showBankDetailsModal" :title="'Bank Details'" no-close-on-backdrop no-close-on-esc @hide="closeBankDetailsModal">
      <div class="col-md-12" v-if="bankDetailsList && bankDetailsList.length > 0 && bankDetailsList[0]">
        <span>
          <b>Account Holder:</b>&nbsp; {{bankDetailsList[0].ac_holder_name}}<br/>
          <b>Bank:</b>&nbsp; {{bankDetailsList[0].bank_name}}<br/>
          <b>Branch:</b>&nbsp; {{bankDetailsList[0].branch}}<br/>
          <b>Account No:</b>&nbsp; {{bankDetailsList[0].ac_no}}<br/>
          <b>IFSC Code:</b>&nbsp; {{bankDetailsList[0].ifsc_code}}<br/>
          <b>SWIFT Code:</b>&nbsp; {{bankDetailsList[0].swift_code}}<br/>
        </span>
        <label>Cheque Book Screen Shot <span class="primary-color font-size-16">*</span></label>
        <div class="form-group row align-items-center ml-1">
          <div class="profile-img-edit border" style="height: 200px; width: 300px;">
            <img v-if="vmChequeImg" :src="vmChequeImg" alt="profile-pic " style="height: 100%; width: 100%; object-fit: cover; overflow: hidden;" />
            <i v-else class="fas fa-image d-flex justify-content-center align-items-center pointer" style="font-size: 5rem; height:100%; color: #c1c1c1;"></i>
          </div>
          <span class="text-danger" ref="coverPicError"></span>
        </div>
      </div>
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" variant="secondary" @click="closeBankDetailsModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal><!-- Banking Details -->

      <!-- Payout Details View -->
      <b-modal size="xl" v-model="showPayoutDetailsViewModal" :title="'Payout Details'" no-close-on-backdrop no-close-on-esc hide-footer @hide="closePayoutDetailsViewModal">
        <PayoutDetailsView :propPayoutDetails="propPayoutDetails"/>
      </b-modal><!-- Payout Details View -->

      <!-- Redemption processing Modal -->
      <ProcessRedemption v-if="propRedemptionData" :key="showRedemptionProcessingModal" :propShowRedemptionProcessingModal="showRedemptionProcessingModal" :propRedemptionData="propRedemptionData" @emitCloseRedemptionProcessingModal="emitCloseRedemptionProcessingModal" :propOrgId="cvOrgId" /><!-- Redemption processing Modal -->
      <!-- Redemption processing Modal -->

      <!-- GST Invoice Upload Modal -->
      <b-modal size="xl" v-model="showGstInvoiceUploadModal" :title="'Invoice'" no-close-on-backdrop no-close-on-esc @hide="closeGstInvoiceUploadModalModal">
        <UploadDocs :propDocsList="vmGstInvoiceFormData" :propUploadInputLabel="`Attach Invoices`" :propAllowedExtensions="`application/pdf`" @emitGetLatestDocs="emitGetLatestDocs" />
        <p v-if="userData.user_role == 'USERROLE11116' && (!redeemReq || !redeemReq.invoice)">
          <button type="button" class="btn btn-primary ml-1 mt-1" @click="uploadGstInvoice()">Upload GST Invoice</button>
        </p>
        <p v-else-if="userData.user_role == 'USERROLE11116' && redeemReq && redeemReq.invoice">
          <button type="button" class="btn btn-primary ml-1 mt-1" @click="editGstInvoice()">Edit GST Invoice</button>
        </p>

        <template #modal-footer="">
          <b-button size="sm" class="pull-left" variant="secondary" @click="closeGstInvoiceUploadModalModal()">
            {{cvbtnModalCancel}}
          </b-button>
        </template>
      </b-modal><!-- GST Invoice Upload Modal -->

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { socialvue } from "../../../../config/pluginInit.js"
import userPermission from "../../../../Utils/user_permission.js"
import { PayRedemption } from "../../../../FackApi/api/PayRedemption.js"
import pdfLogo from "../../../../assets_gide/img/logo/pdfLogo.png"
import ProcessRedemption from "./ProcessRedemption.vue"
import RedemptionStatusJson from "../../../../FackApi/json/RedemptionStatus.json"
import ColorCodes from "../../../../Utils/colorcodes.js"
import UploadDocs from "../../../../components/UploadDocs.vue"
import PayoutDetailsView from "./PayoutDetailsView.vue"
import OrgSaasTaxDocuments from "../OrgSaasTaxDocuments.vue"
import { UserBillDetails } from "../../../../FackApi/api/UserBillDetails.js"
import Multiselect from "vue-multiselect"
import Utility from "../../../../Utils/utility.js"
import "vue-multiselect/dist/vue-multiselect.min.css"

export default {
  name: "OrgSaasRedemptionAdminDashboard",
  components: {
    ProcessRedemption,
    UploadDocs,
    PayoutDetailsView,
    OrgSaasTaxDocuments,
    Multiselect
  },
  data () {
    return {
      apiName: "pay_redemption_list_admin",
      showTaxInfoDocumentModal: false,
      cvTaxDocumentModalHeader: "Tax Info",
      showRedemptionProcessingModal: false,
      propTaxModuleObjId: null,
      propRedemptionData: null,
      cvCardTitle: "GIDEPreneur Finance Dashboard",
      cvSearchText: "Type to Search",
      cvbtnModalCancel: "Close",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Finance Dashboard",
      sortBy: "name",
      sortDesc: false,
      columns: [],
      payredeemObjList: [],
      filter: null,
      filterOn: [],
      totalRows: 1,
      whereFilter: {
        org_id: null,
        redemption_status: []
      },
      search_param: "",
      currentBatchNo: 1,
      dataPerPage: 100,
      showLoadMoreBtn: true,
      redemptionStatusStringObj: RedemptionStatusJson,
      organisationObjList: null,
      pdfLogo: pdfLogo,
      cvOrgId: null,
      showGstInvoiceUploadModal: false,
      vmGstInvoiceFormData: [],
      propPayoutDetails: null,
      showPayoutDetailsViewModal: false,
      showBankDetailsModal: false,
      bankDetailsList: [],
      vmChequeImg: null,
      selectedRedemptionStatusOptions: null,
      VUE_APP_GPSUPPORT_MAIL: `mailto:${process.env.VUE_APP_GPSUPPORT_MAIL}`,
      doCopy: Utility.doCopy
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    statusOptions () {
      return Object.entries(this.redemptionStatusStringObj).map(
        ([key, label]) => ({ value: key, label })
      )
    }
  },
  beforeMount () {
    // Auth Access for Current User Role. Also allow to open this component in Modal Box and not in a URL as URL is only for GIDE Team
    if (this.userData.user_role != "USERROLE11111" && this.userData.user_role != "USERROLE11118") {
      if (!userPermission(this, this.userData, this.apiName)) {
        this.$router.back()
      }
    }
  },
  async mounted () {
    socialvue.index()

    if (this.userData.user_country == 99) {
      this.columns = [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Redemption Status", key: "pay_redeem_id", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Organization", key: "org_id", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Redemption Period", key: "redemption_period", class: "text-left align-text-top", sortable: true },
        { label: "Revenue", key: "revenue_inr", class: "text-right align-text-top", sortable: true },
        { label: "Commission with GST (INR)", key: "commission_inr_with_gst", class: "text-right align-text-top", sortable: true },
        // { label: "Commission without GST (INR)", key: "commission_inr_without_gst", class: "text-right align-text-top", sortable: true },
        { label: "Payout", key: "payout_amount", class: "text-right align-text-top w-200px", sortable: true },
        { label: "Payout Details", key: "payout_tid", class: "text-left align-text-top w-200px", sortable: true }
      ]
    }
    else {
      this.columns = [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Redemption Status", key: "pay_redeem_id", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Organization", key: "org_id", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Redemption Period", key: "redemption_period", class: "text-left align-text-top", sortable: true },
        { label: "Revenue", key: "revenue_inr", class: "text-right align-text-top", sortable: true },
        { label: "Commission with GST (INR)", key: "commission_inr_with_gst", class: "text-right align-text-top", sortable: true },
        { label: "Commission without GST (INR)", key: "commission_inr_without_gst", class: "text-right align-text-top", sortable: true },
        { label: "Payout", key: "payout_amount", class: "text-right align-text-top w-200px", sortable: true },
        { label: "Payout Details", key: "payout_tid", class: "text-left align-text-top w-200px", sortable: true }
      ]
    }

    // If there are already values in whereFilter, map them back to options
    this.selectedRedemptionStatusOptions = this.whereFilter.redemption_status.map(val => {
      const option = this.statusOptions.find(opt => opt.value === val)
      return option || null // just in case
    }).filter(Boolean)

    this.payRedemptionListAdmin()
    this.getDashboardFilters()
  },
  methods: {
    /**
     * handle Selection Change
     */
    handleSelectionChange (selectedOptions) {
      // Safely extract values only
      if (!Array.isArray(selectedOptions)) {
        this.whereFilter.redemption_status = []
        return
      }

      this.whereFilter.redemption_status = selectedOptions.map(opt => opt.value)

      if (typeof this.getFilteredData === "function") {
        this.getFilteredData()
      }
    },
    /**
     * getBankDetailsOfUser
     */
    async getBankDetailsOfUser (billId) {
      try {
        let userBillDetails = await UserBillDetails.UserBillDetailsView(this, { bill_id: billId })
        if (!userBillDetails.resp_status) {
          this.toastMsg = "Billing details not found"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        userBillDetails = userBillDetails.resp_data.data

        if (userBillDetails.bank_ac) {
          try {
            userBillDetails.bank_ac = JSON.parse(userBillDetails.bank_ac)
          }
          catch (jsonParseErr) {
            console.error("Exception in parsing bank a/c details", jsonParseErr)
          }

          if (userBillDetails.bank_ac.length > 0) {
            this.bankDetailsList = userBillDetails.bank_ac
            this.vmBankDetailsFormData = this.bankDetailsList[0]

            if (JSON.parse(this.vmBankDetailsFormData.cheque_img).length) {
              this.vmChequeImg = JSON.parse(this.vmBankDetailsFormData.cheque_img)[0].url
              this.chequeImgList = JSON.parse(this.vmBankDetailsFormData.cheque_img)
            }
          }
        }
        else {
          this.toastMsg = "Banking details not found"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }
        this.showBankDetailsModal = true
      }
      catch (err) {
        console.error("Exception in getBankDetailsOfUser() and err: ", err.message)
      }
    },
    /**
     * closeBankDetailsModal
     */
    closeBankDetailsModal () {
      this.showBankDetailsModal = false
    },
    /**
     * openTaxInfoModal
    */
    async openTaxInfoModal (item) {
      this.propTaxModuleObjId = item.org_id
      this.showTaxInfoDocumentModal = true
    },
    /**
     * Close Tax Info
     */
    async closeTaxInfoEditModal () {
      try {
        this.showTaxInfoDocumentModal = false
      }
      catch (err) {
        console.error("Exception occurred at closeTaxInfoEditModal() and Exception:", err.message)
      }
    },
    /**
     * openPayoutDetailsViewModal
     */
    openPayoutDetailsViewModal (redeemData) {
      try {
        this.propPayoutDetails = {
          payout_tid: redeemData.payout_tid,
          payout_amount: redeemData.payout_amount
        }

        this.propPayoutDetails.payout_tid_img = redeemData.payout_tid_img

        this.showPayoutDetailsViewModal = true
      }
      catch (err) {
        console.error("Exception in openPayoutDetailsViewModal() and err: ", err.message)
      }
    },
    /**
     * closePayoutDetailsViewModal
     */
    closePayoutDetailsViewModal () {
      this.showPayoutDetailsViewModal = false
    },
    /**
     * openUploadGstInvoiceModal
     */
    openUploadGstInvoiceModal (item) {
      try {
        this.redeemReq = item
        if (item.invoice) {
          if (typeof item.invoice == "string") {
            this.vmGstInvoiceFormData = JSON.parse(item.invoice)
          }
          else {
            this.vmGstInvoiceFormData = item.invoice
          }
        }
        this.showGstInvoiceUploadModal = true
      }
      catch (err) {
        console.error("Exception in openUploadGstInvoiceModal() and err: ", err.message)
      }
    },
    /**
     * closeGstInvoiceUploadModalModal
     */
    closeGstInvoiceUploadModalModal () {
      this.showGstInvoiceUploadModal = false
    },
    /**
     * emitGetLatestDocs
     */
    emitGetLatestDocs (updatedDocsList) {
      this.vmGstInvoiceFormData = updatedDocsList
    },
    /**
     * getBgFor
     */
    getBgFor (redemptionStatus) {
      switch (redemptionStatus) {
        case "TOBEOTPVERF":
          return ColorCodes.getBgColor(50)
        case "TOBEAPPROVED":
          return ColorCodes.getBgColor(13)
        case "NOTREDEEMED":
          return ColorCodes.getBgColor(15)
        case "TOBEPAID":
          return ColorCodes.getBgColor(13)
        case "PAID":
          return ColorCodes.getBgColor(3)
        case "TOBERECOVERED":
          return ColorCodes.getBgColor(9)
        case "RECOVERED":
          return ColorCodes.getBgColor(30)
        case "PGW_CAPTURED":
          return ColorCodes.getBgColor(32) // Teal Green
        case "PGW_SUCCESS":
          return ColorCodes.getBgColor(32) // Teal Green
        case "PGW_REFUNDED":
          return ColorCodes.getBgColor(15) // Red with orange tint
        case "REJECTED":
          return ColorCodes.getBgColor(27)
        case "NOT_ELIGIBLE":
        default:
          return ColorCodes.getBgColor(4)
      }
    },
    /**
     * searchpayredeemWithParams
     */
    async searchpayredeemWithParams () {
      if (this.whereFilter.search_param.length == 0) {
        this.showLoadMoreBtn = true
      }
      this.currentBatchNo = 1
      this.payRedemptionListAdmin()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.payRedemptionListAdmin(true)
    },
    /**
     * payRedemptionListAdmin
     */
    async payRedemptionListAdmin (loadViaLoadMore = false, downloadCsv = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param
        this.whereFilter.downloadCsv = downloadCsv

        let payredeemListResp = await PayRedemption.payRedemptionListAdmin(this, this.whereFilter)
        if (!payredeemListResp.resp_status) {
          if (this.currentBatchNo > 1) {
            // anything less than 1 (which is the first page) becomes an invalid prop for the b-pagination component
            this.currentBatchNo--
          }
          this.showLoadMoreBtn = false
          return
        }
        this.totalRows = this.payredeemObjList.length

        if (payredeemListResp.resp_status) {
          if (downloadCsv) {
            window.open(payredeemListResp.resp_csv_file_url)
            return
          }

          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.payredeemObjList = [ ...payredeemListResp.resp_data.data ]
          }
          else {
            this.payredeemObjList = [ ...this.payredeemObjList, ...payredeemListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.payredeemObjList.forEach((s, index) => {
            s.id = index + 1
            s.payout_tid_img = JSON.parse(s.payout_tid_img)
            s.invoice = JSON.parse(s.invoice)
            s.history = JSON.parse(s.history)
          })
        }
        else {
          this.currentBatchNo--
          this.showLoadMoreBtn = false
          this.currentBatchNo = this.currentBatchNo - 1
          this.toastMsg = payredeemListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at payRedemptionListAdmin() and Exception:", err)
      }
    },
    /**
     * getDashboardFilters
     */
    async getDashboardFilters () {
      try {
        const redemptionFiltersResp = await PayRedemption.payRedemptionFilterGet(this)
        if (redemptionFiltersResp.resp_status) {
          this.organisationObjList = redemptionFiltersResp.resp_data.data
        }
      }
      catch (err) {
        console.error("Exception in getDashboardFilters() and err: ", err.message)
      }
    },
    /**
     * getFilteredData
     */
    getFilteredData () {
      this.currentBatchNo = 1
      this.payRedemptionListAdmin()
    },
    /**
     * view BreakDown
     */
    async viewBreakDown (item) {
      window.open(`/revenue_dashboard?org_id=${item.org_id}&pay_redeem_id=${item.pay_redeem_id}`)
    },
    /**
     * view Redemption
     */
    viewRedemption (item) {
      window.open(`/redemption_dashboard?org_id=${item.org_id}`)
    },
    /**
     * openProcessRedemptionModal
     */
    openProcessRedemptionModal (item) {
      this.cvOrgId = item.org_id
      this.propRedemptionData = {
        redemption_period: item.redeem_for_period,
        ...item
      }
      this.showRedemptionProcessingModal = true
    },
    /**
     * emitCloseRedemptionProcessingModal
     */
    emitCloseRedemptionProcessingModal (redemptionProcessStatus = false) {
      if (redemptionProcessStatus) {
        this.whereFilter.redemption_status = ["PAID"]
      }
      this.payRedemptionListAdmin()
      this.showRedemptionProcessingModal = false
    },
    /**
     * backendCsvDownload
     */
    async backendCsvDownload () {
      this.payRedemptionListAdmin(false, true)
    }
  }
}
</script>
<style>
  .pdfLogoImg {
    height: 32px;
    width: 32px;
    object-fit: contain;
    border: 2px solid aliceblue;
    margin-bottom: 6px;
  }
</style>
